import { loggedIn, userSignedUp, userApproved, userNotActive } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import { fetchUser } from '../../../redux/modules/user';

export const page = {
    path: paths.signup.ready,
    isAllowed: [loggedIn, userSignedUp, userApproved, userNotActive],
    action: () => fetchUser(),
};

export const actions = {};
